import React from 'react'
import ReactPlayer from 'react-player'

export default function PostVideo({ content }) {
  // const { video } = content
  // const videoUrl = video?.localFile?.publicURL  // local download, seems not working as of 2022-9
  // const videoUrl = video?.mediaItemUrl  // from wp.analyticpartners, blocked by ip detection

  const { filenameLocal } = content
  const videoUrl = `/videos/${filenameLocal}` // wp field + need to add locally in static folder

  return (
    <section className='image'>
      <ReactPlayer
        url={videoUrl}
        className='react-player'
        // loop
        // playing
        // muted
        // playsinline
        config={{
          file: {
            attributes: {
              controlsList: 'nodownload noplaybackrate',
              disablePictureInPicture: true,
            },
          },
        }}
        controls
        width='100%'
        height='100%'
      />
    </section>
  )
}
